var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ICacheDataSourceType } from '../../DataSource/CacheDataSource/ICacheDataSource';
import { StateMap } from './../../../Domain/DTOs/Module/ModuleDTO';
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { IAnalyticsDataSourceType } from '../../DataSource/AnalyticsDataSource/IAnalyticsDataSource';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { Dimensions, Platform } from 'react-native';
import * as Application from 'expo-application';
import { uuid } from './../../../Helpers';
import { Observable } from '../../Observable/Observable';
import { Device } from '../../../Helpers/Device/Device';
let UserApplicationRepository = class UserApplicationRepository {
    constructor(cache, apiDataSource, analyticsDataSource) {
        this.cache = cache;
        this.apiDataSource = apiDataSource;
        this.analyticsDataSource = analyticsDataSource;
        this.userApplication = new Observable({});
    }
    init() {
        const userApplicationCache = this.cache.getCache(StateMap.user_application).data;
        const applicationBuild = this.cache.getCache(StateMap.application_build).data;
        const reactBuild = this.cache.getCache(StateMap.react_build).data;
        const device = this.cache.getCache(StateMap.device).data;
        if (!device.value) {
            device.next(this.getDevice());
        }
        Observable.combine(this, [userApplicationCache, applicationBuild, reactBuild, device]).observe(this, ([userApplication, applicationBuild, reactBuild, device]) => {
            const update = Object.assign(Object.assign(Object.assign({}, userApplication), this.userApplication.value), { version: Application.nativeApplicationVersion, os: Platform.OS, guid: (userApplication === null || userApplication === void 0 ? void 0 : userApplication.guid) || uuid(), device: Device.modelName, react_bundle_version: reactBuild, os_version: Device.version, build: applicationBuild });
            this.userApplication.next(update);
            this.apiDataSource.setApplicationBuild(applicationBuild);
            this.apiDataSource.setReactBuild(reactBuild);
            this.analyticsDataSource.setAppVersion(applicationBuild);
            this.apiDataSource.setDevice(device);
        });
    }
    getApplicationBuild() {
        let value = this.cache.getCache(StateMap.application_build).data.value;
        if (typeof value !== 'number') {
            const newValue = Number(value);
            if (!isNaN(newValue)) {
                value = newValue;
            }
        }
        return value;
    }
    getType(width) {
        return Platform.select({
            web: width < 768
                ? 'web-mobile'
                : 'web-desktop',
            ios: 'ios-app,app',
            android: 'android-app,app'
        });
    }
    getScreenSize(width) {
        if (width <= 480) {
            return 'extra-small,small';
        }
        if (width <= 568) {
            return 'extra-small,small';
        }
        if (width <= 667) {
            return 'small,extra-small';
        }
        if (width <= 736) {
            return 'medium,small';
        }
        if (width <= 812) {
            return 'large,medium';
        }
        if (width <= 896) {
            return 'extra-large,large';
        }
        return 'extra-large,large';
    }
    updatePushToken(token) {
        return this.updateUserApplication({ push_token: token });
    }
    get() {
        return this.userApplication;
    }
    updateUserApplication(update) {
        const params = {
            path: 'user_applications',
            data: Object.assign(Object.assign(Object.assign({}, this.userApplication.value), update), { id: undefined })
        };
        return this.apiDataSource.post(params)
            .then(({ data }) => {
            if (!data) {
                data = {};
            }
            return this.userApplication.update(Object.assign(Object.assign({}, update), data));
        });
    }
    getDevice() {
        const width = Dimensions.get('screen').width;
        return `screen-size=${this.getScreenSize(width)};type=${this.getType(width)}`;
    }
};
UserApplicationRepository = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(ICacheDataSourceType)),
    __param(1, inject(IAPIHTTPDataSourceType)),
    __param(2, inject(IAnalyticsDataSourceType)),
    __metadata("design:paramtypes", [Object, Object, Object])
], UserApplicationRepository);
export { UserApplicationRepository };
